import { types as t } from 'mobx-state-tree';

export const JobStatus = t.enumeration('JobStatus', [
  'full_time',
  'part_time',
  'per_diem',
  'not_specified'
]);
